import { Check } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@@shared/base/Button';
import { Card } from '@@shared/base/Card';

interface ReceiptSentCardProps {
  onFinish: () => void;
}

export const ReceiptSentCard = ({ onFinish }: ReceiptSentCardProps) => {
  const tPayment = useTranslation('translation', { keyPrefix: 'payment' }).t;

  return (
    <Card className="p-8 text-center">
      <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center">
        <Check className="h-12 w-12 text-vk-dark" strokeWidth={3} />
      </div>

      <h2 className="mb-6 font-averta text-xl text-vk-dark">{tPayment('title')}</h2>

      <div className="mb-8 space-y-4 text-vk-dark">
        <p className="text-md font-semibold">{tPayment('subtitle')}</p>
        <p className="text-md leading-relaxed">{tPayment('body')}</p>
      </div>

      <div className="mb-6 rounded-lg bg-gray-100 p-5">
        <h3 className="mb-4 text-center font-semibold text-vk-dark">{tPayment('receiptSentTitle')}</h3>
        <p className="text-center text-sm text-vk-dark">{tPayment('receiptSentDescription')}</p>
      </div>

      <Button onClick={onFinish} className="w-full">
        {tPayment('doneButton')}
      </Button>
    </Card>
  );
};
